// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__1m6FL","Label":"Input_Label__14HTh","InputElement":"Input_InputElement__3-La-","Invalid":"Input_Invalid__3D5cS"};